import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronLeft14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.44964 3.45966L8.5103 4.52032L6.04063 6.98999L8.5103 9.45966L7.44964 10.5203L3.91931 6.98999L7.44964 3.45966Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronLeft14.displayName = 'ChevronLeft14';
export default ChevronLeft14;
